<div class="ate-pulse w-full">
  <div class="h-2.5 bg-gray-200 rounded-full w-48 mb-4"></div>
  <div class="h-2 bg-gray-200 rounded-full mb-2.5"></div>
</div>
